import React from "react";
import { List, Divider } from "@mui/material";
import { SIDEBAR_ITEMS } from "./SidebarItems";
import { SidebarNavItem } from "./SidebarNavItem";
import { useAuth } from "../../hooks/AuthProvider";
import { 
  SidebarDrawer, 
  SidebarToolbar, 
  SidebarLogo, 
  StyledDivider 
} from "./styles/SidebarStyles";
import Logo from "../../assets/logo_alpha.png";
import { SidebarProps, SidebarSectionProps } from "./types/SidebarTypes";

const SidebarSection: React.FC<SidebarSectionProps> = ({ items, section }) => {
  return (
    <>
      {items.length > 0 && (
        <>
          {section === 'admin' && <StyledDivider />}
          <List>
            {items.map((item) => (
              <SidebarNavItem key={item.text} {...item} />
            ))}
          </List>
        </>
      )}
    </>
  );
};

export const Sidebar: React.FC<SidebarProps> = ({ items = SIDEBAR_ITEMS }) => {
  const auth = useAuth();

  const userItems = items.filter((item) => !item.adminOnly);
  const adminItems = auth.isAdmin ? items.filter((item) => item.adminOnly) : [];

  return (
    <SidebarDrawer
      variant="permanent"
      anchor="left"
    >
      <SidebarToolbar>
        <SidebarLogo src={Logo} alt="Logo" />
      </SidebarToolbar>
      <Divider />
      <SidebarSection items={userItems} section="user" />
      <SidebarSection items={adminItems} section="admin" />
    </SidebarDrawer>
  );
};
